<template>
  <F360ScreenFrame fill class="insights-agente-body-frame">
    <div class="insigth-desativado-frame">
      <div class="insigth-desativado-frame__content">
        <div class="insigth-desativado-frame__content-icon">
          <MaterialIcon icon="check_circle" />
        </div>
        <div class="insigth-desativado-frame__content-text">
          <h3>Agente de DRE desativado</h3>
          <p>
            Os relatórios não serão mais gerados até que você ative novamente
          </p>
          <F360Button filled @click="handleAtivar">Reativar Agente</F360Button>
        </div>
      </div>
    </div>
  </F360ScreenFrame>

  <InsightConfiguracaoDialog
    :gerarRelatorio="false"
    v-model="isConfiguracaoDialogOpen"
    :tipo="ETipoConfiguracao.ATIVAR"
  />
</template>

<script setup lang="ts">
import MaterialIcon from "@/ui/components/Icons/MaterialIcon/MaterialIcon.vue";
import F360Button from "@/ui/components/Buttons/Button/F360Button.vue";
import InsightConfiguracaoDialog from "../../../../widgets/configuracao/InsightConfiguracaoDialog.vue";
import { ref } from "vue";
import { ETipoConfiguracao } from "../../../../widgets/configuracao/types";

const isConfiguracaoDialogOpen = ref(false);

const handleAtivar = () => {
  isConfiguracaoDialogOpen.value = true;
};
</script>

<style scoped lang="scss">
.insigth-desativado-frame {
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 32px 0;

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &-icon {
      width: 40px;
      height: 40px;
      background-color: _map.get($map: $neutro, $key: 200);
      color: _map.get($map: $neutro, $key: 0);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &-text {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      h3 {
        margin: 16px 0 0;
        padding: 0;
      }

      p {
        margin: 8px 0 20px;
      }
    }
  }
}
</style>
